import { type OptionsFetchQueryResult, OptionsType } from '@openx/types/options.ts';
import type { UseQueryOptions } from '@openx/types/reactQuery.ts';
import { useTranslation } from 'react-i18next';

import { useOptionsFetch } from './generics/useOptionsFetch.tsx';

export function useVideoPlacementOptionsFetch(queryOptions?: UseQueryOptions<OptionsFetchQueryResult>) {
  const { t } = useTranslation();
  const {
    isLoading: isVideoPlacementLoading,
    data: videoPlacement,
    refetch: refetchVideoPlacement,
  } = useOptionsFetch({
    errorMessage: t('Failed to fetch placement options'),
    mapByKey: 'id',
    optionType: OptionsType.VIDEO_PLACEMENT,
    queryOptions,
  });

  return {
    isVideoPlacementLoading,
    refetchVideoPlacement,
    videoPlacement,
  };
}
